import { PropsWithChildren } from 'react';

import ChannelProvider from '@/channels/ChannelProvider';
import { datePaginatedTransactionsChannelName } from '@/channels/utils/channelNames';

import { Props } from './types';

const DatePaginatedTransactionsChannel = ({ children, personId }: PropsWithChildren<Props>) => {
  return (
    <ChannelProvider channelName={datePaginatedTransactionsChannelName(personId)}>
      {children}
    </ChannelProvider>
  );
};

export default DatePaginatedTransactionsChannel;
